import { CaretRightIcon } from '@phosphor-icons/react'
import Link from 'next/link'
import { BardFlchCaretLinks as BardFlchCaretLinksType } from '@/src/@types/statamic'

export default function BardFlchCaretLinks({ links }: BardFlchCaretLinksType) {
  if (!links?.length) return null

  return (
    <div className="divide-y divide-gray-150 border-y border-gray-150">
      {links.map((careLink, index) => (
        <Link
          key={index}
          href={careLink.link.url}
          className="group flex items-center gap-2 py-3"
        >
          <span className="text-lg font-black">{careLink.title}</span>
          <CaretRightIcon
            size={20}
            weight="bold"
            className="shrink-0 text-blue-700 transition-transform group-hover:translate-x-1"
          />
        </Link>
      ))}
    </div>
  )
}
